// extracted by mini-css-extract-plugin
module.exports = {"star-icon":"_1-d8H","starIcon":"_1-d8H","rating":"_1OuW4"};